import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './core/guards/auth-guard';
import { QrGeneratorComponent } from './modules/evl/components/qr-generator/qr-generator.component';
import { ViewContentBodyComponent } from './modules/cms/components/content-entry/view-content-body/view-content-body/view-content-body.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./modules/report/report.module').then(
            (m) => m.ReportModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./pages/apps/apps.routes').then((m) => m.AppsRoutes),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'lookup/sys',
        loadChildren: () =>
          import('./modules/sys/sys.module').then(
            (m) => m.SysModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'lookup/cms',
        loadChildren: () =>
          import('./modules/cms/cms.module').then(
            (m) => m.CmsModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'lookup/ntf',
        loadChildren: () =>
          import('./modules/ntf/ntf.module').then(
            (m) => m.NTFModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'lookup/emm',
        loadChildren: () =>
          import('./modules/emm/emm.module').then(
            (m) => m.EmmModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'vehicle/details',
        loadChildren: () =>
          import('./modules/auth/auth.module').then(
            (m) => m.AuthModule
          ),
      },
      {
        path: 'lookup/flw',
        loadChildren: () =>
          import('./modules/flw/flw.module').then((m) => m.FlwModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'lookup/evl',
        loadChildren: () =>
          import('./modules/evl/evl.module').then(
            (m) => m.EvlModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'lookup/hcm',
        loadChildren: () =>
          import('./modules/hcm/hcm.module').then(
            (m) => m.HcmModule
          ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'user-evaluation/qrGenerator',
        children: [
          {
            path: 'qr',
            component: QrGeneratorComponent,
            data: { title: "Generate QR Code" }
          }
        ],
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
      }
    ],
  },
  {
    path: 'user-evaluation',
    loadChildren: () =>
      import('./modules/evl/evl.module').then(
        (m) => m.EvlModule
      ),
  },
  {
    path: "content/entry/:lang/:id",
    component: ViewContentBodyComponent,
    data: { title: "Content.ContentEntry.ViewBody" }
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(
        (m) => m.AuthModule
      ),
  },
  {
    path: 'download',
    loadChildren: () =>
      import('./modules/download-app-redirect/download-app-redirect.module').then(
        (m) => m.DownloadAppRedirectModule
      ),
  },
  {
    path: "unauthorized",
    component: UnauthorizedComponent,
    data: { title: "Unauthorized" }
  },
  {
    path: '**',
    redirectTo: 'auth/sign-in',
  }
];